<div class="select-columns-container">
  <opath-core-nav-header
    style="width: 100%"
    [title]="translation?.title"
    [buttons]="headerButtons"
    [height]="100"
    (onFilterOptionChanged)="filterOptionChanged($event)"
    (onSearchTermChanged)="searchTermChanged($event)"
    (onbuttonStateChanged)="refreshButtonsState()"
  >
  </opath-core-nav-header>

  <dx-scroll-view class="scroller" direction="both" #scroller>
    <abc-tree
      class="tree"
      #tree
      [scrollDirection]="'horizontal'"
      [searchEnabled]="false"
      [searchValue]="searchTerm"
      [searchMode]="currentFilterOption?.searchMode"
      [showCheckBoxesMode]="'normal'"
      [selectionMode]="'multiple'"
      hasItemsExpr="children"
      [data]="treeData"
      (onItemExpanded)="onItemExpanded($event)"
      (onItemSelectionChanged)="onItemSelectionChanged($event)"
    >
    </abc-tree>
  </dx-scroll-view>
  <div class="actions">
    <abc-button
      [width]="'100%'"
      class="action-button"
      [disabled]="selectedNodes.length === 0"
      (click)="insertColumnsToQuery()"
      text="{{ translation?.ok }}"
    ></abc-button
    ><abc-button
      [width]="'100%'"
      class="action-button"
      (click)="emptySelection()"
      text="{{ translation?.cancel }}"
    ></abc-button>
  </div>
</div>
